import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import styled, { ThemeProvider } from 'styled-components'
import { GlobalVariables } from 'Globals/GlobalVariables'
import { getTheme } from '../../theme/config'
import AgesChart from 'components/AgesChart'
import { ReactElement } from 'react'
import DependanceCharts from 'components/DependanceCharts'
import WomenChart from 'components/WomenChart'
import Sondages from 'components/Sondages'
import { Small } from 'theme/styles'
import { TextWidth, ContentWidth } from '@ta-interaktiv/react-disco-grid'

const MainComponent = ({
  tenant,
  colorMode,
  properties,
  trackEvent,
}: MicroFrontendProps) => {
  const theme = getTheme(colorMode, tenant)
  const modules: { [key: string]: ReactElement } = {
    populationChart: <AgesChart />,
    oldPopChart: <DependanceCharts />,
    womenChart: <WomenChart />,
    ageInequalitiesChart: <div>Age inequalities chart</div>,
    sondagesChartA: (
      <div style={{ marginBottom: 50 }}>
        <TextWidth>
          <Sep />
          <Title>Écarts entre sondeurs</Title>
          <Lead>Différence entre les pourcentages d'intention de Oui aux dernières votations fédérales selon l'institut LeeWas et gfs.bern.</Lead>
        </TextWidth>
        <ContentWidth>
          <Sondages />
        </ContentWidth>
        <TextWidth>
          <Small>
            <strong>Source</strong>: Rapport de la 2<sup>e</sup> vague de l'enquête sur les votations populaires fédérales du 3 mars 2024 - LeeWas
          </Small>
        </TextWidth>
      </div>
    ),
  }

  return (
    <AppContainer $colorMode={colorMode}>
      <ThemeProvider theme={theme}>{modules[properties.module]}</ThemeProvider>
    </AppContainer>
  )
}

const AppContainer = styled(TamediaStyles)`${GlobalVariables}
  font-family: var(--font-sans-serif);
  font-size: 1.8rem;
  line-height: 3rem;
  position: relative;
`

const Title = styled.div`
  line-height: 1.2;
  font-weight: bold;
  margin-bottom: .5em;
`

const Lead = styled.div`
  line-height: 1.4;
`

const Sep = styled.div`
  width: 100px;
  height: 4px;
  margin: 1em 0;
  background-color: var(--text-color);
`

export default MainComponent
